import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './SpreadsheetTable.html?raw';
import "./SpreadsheetTableTypes";
import on from 'dojo/on';
import lang from 'dojo/_base/lang';
import NumberInput from '../NumberInput/NumberInput';
import moreCoreEdit from '../Edit/Edit';
import _uiFrameMixin from '../Container/uiFrame';
import EntityStore from '../../Tools/EntityStore';
import { EntityHelpers, ExtraHelpers, HtmlHelpers, StringHelpers, ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import _StatefulBase from '../_StatefulBase/_StatefulBase';
import Button from '../Button/Button';
import RadioGroup from '../RadioGroup/RadioGroup';
import _ControlBase from '../_ControlBase/_ControlBase';

interface AsyncCalculationQueueEntry<T> {
    status: "pending" | "running" | "done" | "cancelled" | "error";
    transactionID: string;
    cells: Record<string, SpreadsheetTableTypes.AsyncCellCalculationData<T>>
    results?: Array<SpreadsheetTableTypes.AsyncCellCalculationResponse>;
}

class SpreadsheetTable<T> extends compose(_uiFrameMixin) {
    templateString: any = template;

    private _sourceData: Array<T>;
    private dataStore: MdsLax<InstanceType<typeof EntityStore<T>>>;
    private tableData: SpreadsheetTableTypes.Table<T>;
    private tableContainer: HTMLDivElement;

    private isReadonly: boolean = false;
    private isGlobalEditingMode: boolean = false;

    private calculationQueue: Array<{
        targetCell: SpreadsheetTableTypes.TableCell<T>,
        sourceCell: SpreadsheetTableTypes.TableCell<T>,
        oldValue: any,
        newValue: any,
        status: "new" | "pending" | "done" | "error" | "cancelled";
    }>;

    private cells: Record<string, SpreadsheetTableTypes.DataCell<T>>;
    private _config: SpreadsheetTableTypes.SpreadsheetConfig;
    private _startupState: "empty" | "setup" | "ready" = "empty";
    setup(config: SpreadsheetTableTypes.SpreadsheetConfig,
        data?: Array<T>) {

        this._startupState = "setup";

        this.setReadonly(config.readonly === true);
        this.isGlobalEditingMode = config.permanentEditingMode === true;

        if (config) {
            this._config = lang.clone(config);
        }

        this.tableData = {
            columns: {},
            rows: {},
            node: null,
            headerRowNode: null,
            rowIdAttribute: this._config.rowIdAttribute,
            rowLabelAttribute: this._config.rowLabelAttribute,
            summaryRows: {},
            rowActions: this._config.rowActions
        };

        //if (this._config.title) {
        //    this.heading.innerHTML = this._config.title;
        //}
        this.hideNode(this.heading, !this._config.title)

        this.calculationQueue = [];
        this._asyncCalculationQueue = [];
        this.cells = {};

        //// columns sortieren!
        //let newMap = {};
        //let sortArray = Object.keys(navMap).sort((idA, idB) => (TranslationHelpers.tryTranslate(navMap[idA].label) > TranslationHelpers.tryTranslate(navMap[idB].label) ? 1 : -1));
        //sortArray.forEach(key => newMap[key] = navMap[key]);

        // Order-Attribute vorbereiten und Array vorsortieren
        let count = 0;
        for (let descriptor of this._config.columns) {
            count++;
            if (typeof descriptor.order != "number") {
                descriptor.order = 9999 + count;
            }
        }
        this._config.columns.sort((col1, col2) => col1.order - col2.order);

        // aus dem Deskriptor wird eine Column-Instanz (enthält dann u.a. die konkreten Nodes)
        for (let descriptor of this._config.columns) {
            //let clone = lang.clone(descriptor);
            // Dubletten prüfen!
            if (this.tableData.columns[descriptor.columnID]) {
                console.warn(this.id + ": ACHTUNG mehrfache ColumnID in Konfiguration!", this._config.columns);
                alert(this.id + ": Doppelte ColumnID in Konfiguration! " + descriptor.columnID);
            }
            this.tableData.columns[descriptor.columnID] = {
                ...descriptor,
                //order: Object.keys(this.tableData.columns).length,
                cells: {},
                summaryCells: {},
                actionContainerNode: null,
                actionContainerNodePrimary: null,
                headerCellNode: null,
                infoTextNode: null,
                labelNode: null,
                unitLabel: TranslationHelpers.tryTranslate(descriptor.unitLabel),
                heading: TranslationHelpers.tryTranslate(descriptor.heading),
                infoText: TranslationHelpers.tryTranslate(descriptor.infoText),
                actions: {}
            }

            // Achtung, die Columns sind jetzt aus irgendeinemgruund ggf anders sortiert.

            let column = this.tableData.columns[descriptor.columnID];

            if (!column.headerStyleFormatter && this._config.headerStyleFormatter) {
                column.headerStyleFormatter = this._config.headerStyleFormatter;
            }

            if (!column.dataCellStyleFormatter && this._config.cellStyeFormatter) {
                column.dataCellStyleFormatter = this._config.cellStyeFormatter
            }

            // wenn es ein Callback ist, muss das erst zu gegebenem Zeitpunkt ermittelt werden
            if (column.editable !== false && typeof this._config.cellEditableCheck == "function") {
                column.editable = this._config.cellEditableCheck;
            }
            
            if (descriptor.actions?.length) {
                for (let actionName in descriptor.actions) {
                    let action = descriptor.actions[actionName];

                    column.actions[actionName] = {
                        ...action, button: null
                    };
                }
            }
        }

       

        this.setData(data);
        this.setTitles(this._config.title);

        this._continueSetup();
    }

    setData(data: Array<T>) {

        if (data) {
            this._sourceData = lang.clone(data);// JSON.stringify(data);
        } else {
            this._sourceData = null;
        }

        this._continueSetup();
    }
    private _continueSetup() {
        if (!this._sourceData || !this._config) return;



        let data = this._sourceData;
        if (!this._config.rowIdAttribute) {
            this._config.readonly = true;
            this.setReadonly(true);
        } else {
            this.dataStore = new EntityStore();
            this.dataStore.setup(data, this._config.rowIdAttribute);
            this.dataStore.on("change", lang.hitch(this, this._onStoreChange));
            this.dataStore.on("entityChange", lang.hitch(this, this._onStoreChange_Entity));
        }
        //this.dataStore.on("entityChange", lang.hitch(this, this._onStoreEntityChange)); // komm damit nicht weiter - muss das auf Attributebene abfangen, d.h. pro Zelle/Input

        this._drawTable();

        this._sourceData = null;

        setTimeout(lang.hitch(this, function () { this._startupState = "ready"; }), 300);

        this.emit("dirty", false);

    }

    commitChanges() {
        if (this.isReadonly || !this.dataStore) return;

        // Änderungen "commiten" und die Tabelle neu zeichnen, sodass getätigte Änderungen nicht mehr Änderungen markiert sind
        this.dataStore.commit(); // macht zum Glück eh alles der Datastore für uns
        
        let data = this.dataStore.getCurrentCompleteList();
        this.setData(data);
    }

    getData(): Array<T> {
        return this.dataStore.getCurrentCompleteList();
    }

    isDirty(): boolean {
        if (!this.dataStore) return false;

        if (!this.isReadonly && this._startupState == "ready") {
            return this.dataStore.isDirty();
        }
        return false;
    }

    getChangedData(bNullIfNoChange?: boolean): EntityStoreData<T> {
        return this.dataStore.getDiffData(bNullIfNoChange === true);
    }

    setReadonly(bReadonly?: boolean) {
        if (bReadonly !== true && bReadonly !== false) bReadonly = true;

        this.isReadonly = bReadonly === true;

        this.UiModder.domClass.add(this.domNode, "readonly");
    }

    triggerCellFormatting(targetCell?: SpreadsheetTableTypes.TableCell) {


        if (targetCell) {
            this.formatCellValue(targetCell);
            if (this.isDataCell(targetCell)) {
                let summaryCells = this.getSummaryCells(targetCell);
                for (let summaryCell of summaryCells) {
                    this.formatCellValue(summaryCell);
                }
            }
            return;
        }

        let cells = this.getCells();

        for (let cell of cells) {
            this.formatCellValue(cell);
        }

        let summaryCells = [];
        for (let col of this.getColumns()) {
            summaryCells = summaryCells.concat(this.getSummaryCells(col));
        }

        for (let summaryCell of summaryCells) {
            this.formatCellValue(summaryCell);
        }
    }
   
    setCellValue(dataID: string, columnID: string, value: any) {
        let cell = this.getCell(dataID, columnID);
        this._setCellValue(cell, value);
    }

    
    private _setCellValue(cell: SpreadsheetTableTypes.TableCell, value: any, valid?: boolean, overrideDirty?: boolean, skipDependencies?: boolean) {
        if (cell) {
            let oldValue = cell.value;
            cell.value = value;

            cell.pendingValue = false;

            //this.formatCellValue(cell); // wird im validate mitgemacht
            cell.valid = typeof valid == "boolean" ? valid : null;
            this._handleCellValidation(cell);

            // irgendwie erkennen ob die cell eine datacell ist:
            if (this.isDataCell(cell)) {
                let dataCell = cell as SpreadsheetTableTypes.DataCell;
                //let bValueChanged = (dataCell.value != dataCell.originalValue); // evtl bissl zu primitiv für nicht basis-typen
                
                if (dataCell.column.valueAttribute) {
                    
                    let bValueChanged = ExtraHelpers.isSameValue(dataCell.value, dataCell.originalValue) != true;
                    if (bValueChanged === true) {
                        this.dataStore.setEntityAttributeValue(dataCell.row.rowID, dataCell.column.valueAttribute, dataCell.value);
                    }

                    dataCell.dirty = bValueChanged;
                }

                if (overrideDirty === true || overrideDirty === false) dataCell.dirty = overrideDirty;

                this.UiModder.domClass.toggle(dataCell.node, "dirty", dataCell.dirty === true);

                if (dataCell.column.summaryDescriptors?.length) {
                    let summaryCells = this.tableData.columns[dataCell.column.columnID].summaryCells;
                    for (let cellID in summaryCells) {
                        let summaryCell = summaryCells[cellID];
                        this._addCellToCalculationQueue(summaryCell, summaryCell.value, cell);
                    }                    
                }

                if (dataCell.actions) {

                }
            }
            // Abhängigkeiten!!
            if (cell.dependencies?.length && skipDependencies !== true) {
                for (let dependency of cell.dependencies) {
                    let targetCell = dependency.cell;
                    if (this._startupState != "setup" || targetCell.value == undefined) {
                        this._addCellToCalculationQueue(targetCell, oldValue, cell);
                    }
                }                
            }

            // Actions?
            
            this._handleActionStatus(cell);
            this._handleActionStatus(cell.column);
            

        }
    }

    private _addCellToCalculationQueue(targetCell: SpreadsheetTableTypes.TableCell, oldValue: any, sourceCell: SpreadsheetTableTypes.TableCell, ) {
        
        if (sourceCell) {
            let filtered = this.calculationQueue.filter(entry => {
                entry.targetCell.cellID == targetCell.cellID &&
                    entry.sourceCell.cellID == sourceCell.cellID && entry.status == "new"
            });
            if (filtered.length > 0) {
                // es gibt in der Queue schon für diese Targetcell eine Calculation für dieses target und diese source
                // dann können die ja gecancelled werden
                if (!this._calculationQueueRunning) {
                    for (let duplicate of filtered) {
                        duplicate.status = "cancelled";
                    }
                }
            }
        }
        this.calculationQueue.push({
            status: "new",
            newValue: sourceCell?.value,
            oldValue: oldValue,
            sourceCell: sourceCell,
            targetCell: targetCell
        });

        

        this.UiModder.domClass.add(targetCell.node, "calculationPending");
        if (!this._calculationQueueRunning) {
            if (this._calculationQueueTimeout) {
                clearTimeout(this._calculationQueueTimeout);
                this._calculationQueueTimeout = null;
            }

            this._calculationQueueTimeout = setTimeout(lang.hitch(this, this._handleCalculationQueue), 50);
        }
    }


    triggerCellEditableUpdate(row: SpreadsheetTableTypes.DataRow)
    triggerCellEditableUpdate(cell: SpreadsheetTableTypes.DataCell)
    triggerCellEditableUpdate(column: SpreadsheetTableTypes.Column)
    triggerCellEditableUpdate(cells: Array<SpreadsheetTableTypes.DataCell>)
    triggerCellEditableUpdate(unknown) {
        let cells = [];
        if (this.isDataRow(unknown)) {
            let row = unknown as SpreadsheetTableTypes.DataRow;
            cells = this.getCells(row);
        } else if (this.isColumn(unknown)) {
            let col = unknown as SpreadsheetTableTypes.Column;
            cells = this.getCells(col);
        } else if (this.isDataCell(unknown)) {
            let cell = unknown as SpreadsheetTableTypes.Column;
            cells = [cell];
        } else if (unknown.length && typeof (unknown) == "object") {
            cells = unknown;
        }

        for (let cell of cells) {
            this._handleCellEditable(cell);
        }
    }

    private _calculationQueueTimeout;
    private _calculationQueueRunning: boolean = false;
    private _handleCalculationQueue() {
        if (this._calculationQueueRunning == true) return;

        //console.debug(this.id + " calculation queue", this.calculationQueue);

        this._calculationQueueRunning = true;

        for (let entry of this.calculationQueue) {
            if (entry.status == "new") {
                entry.status = "pending";
                let targetCell = entry.targetCell;
                let calculationResult = this._getCalculatedValue(entry.sourceCell, entry.targetCell);

                targetCell.pendingValue = calculationResult?._pending;

                let calcHandled = typeof calculationResult != "undefined";
                
                targetCell.valid = null; // reset - muss nach setcellvalue erst wieder ermittelt werden
                if (calculationResult?.invalidateCell === true) { // außer es ist explizit eine invalidierung gemeldet
                    targetCell.valid = false;
                }

                let overrideDirty = null;
                if (this._startupState == "setup" || (calculationResult?._pending && !targetCell["dirty"])) overrideDirty = false;

                if (!targetCell.pendingValue) {
                    if (calcHandled) {
                        this._setCellValue(targetCell, calculationResult.value, calculationResult.invalidateCell ? false : null, overrideDirty, calculationResult?._pending);
                    } else {
                        this._handleCellValidation(targetCell);
                    }
                }

                entry.status = calcHandled ? calculationResult._pending ? "pending" : "done" : "error";

                this.UiModder.domClass.toggle(targetCell.node, "calculationPending", entry.status == "pending");
                this.UiModder.domClass.toggle(targetCell.node, "calculationError", !calcHandled);
            }
        }

        let filteredArray = this.calculationQueue.filter(entry => entry.status == "new");
        this._calculationQueueRunning = false;

        if (filteredArray.length > 0) this._handleCalculationQueue();
    }

    private _getCalculatedValue(sourceCell: SpreadsheetTableTypes.TableCell, targetCell: SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.cellValueCalcResult & { _pending: boolean } {
        let calculatedValue = undefined;
        let calcHandled = false;
        if (this.isDataCell(targetCell)) {
            let dataCell = targetCell as SpreadsheetTableTypes.DataCell;

            if (typeof dataCell.column.formula.calcFunction == "function") {

                try {

                    let fct = dataCell.column.formula.calcFunction as SpreadsheetTableTypes.cellValueFct;

                    let result = fct(sourceCell.value, sourceCell, dataCell);
                    if (result) {

                        dataCell.valid = true;

                        calculatedValue = result.value;

                        calcHandled = typeof calculatedValue != "undefined";

                        this.UiModder.domClass.remove(dataCell.node, "warningBG");


                        return {
                            _pending: false,
                            value: result.value,
                            invalidateCell: result.invalidateCell
                        };
                    }

                }


                catch (ex) {
                    this.UiModder.domClass.add(dataCell.node, "warningBG");

                    ToasterHelpers.showToast({
                        title: "error calculating cell value " + targetCell.cellID,
                        message: ex,
                        iconClass: toasterIcons.error,
                        timeout: 15000
                    });

                    return {
                        _pending: false,
                        value: undefined,
                        invalidateCell: true
                    };
                }
            } else if (dataCell.column.formula.calcFunction == "asyncQueue") {
                // die Funktion kann nicht hier direkt synchron aufgerufen werden mit Ergebnis. stattdessen muss eine Queue erzeugt werden und auf das Errechnen der Werte von extern gewartet
                this._addCellToAsyncCalculation(dataCell, sourceCell);

                return {
                    _pending: true,
                    invalidateCell: true,
                    value: dataCell.value
                };
            } else if (dataCell.column.formula.calcFunction == "invalidate") {
                // nur invalidieren und gut is
                return {
                    _pending: false,
                    invalidateCell: true,
                    value: dataCell.value
                };
            }
        } else if (this.isSummaryCell(targetCell)) {
            try {
                let summaryCell = targetCell as SpreadsheetTableTypes.SummaryCell;
                
                switch (summaryCell.summaryDescriptor.mode) {
                    case "sum":
                        calculatedValue = this._getSumValue(summaryCell);
                        break;

                    case "function":
                    case "asyncFunction":
                        if (typeof summaryCell.summaryDescriptor.summaryFunction == "function") {
                            let cells = [];
                            for (let cellID in summaryCell.column.cells) {
                                let cell = summaryCell.column.cells[cellID];
                                switch (cell.column.valueType) {
                                    case "empty":
                                        break;

                                    default: cells.push(cell);
                                        break;
                                }
                            }
                            calculatedValue = summaryCell.summaryDescriptor.summaryFunction(cells);
                        }

                        if (summaryCell.summaryDescriptor.mode == "function") {
                            return {
                                _pending: false,
                                value: calculatedValue,
                                invalidateCell: false
                            };
                        } else {
                            // ASYNC!
                            return {
                                _pending: true,
                                value: summaryCell.value,
                                invalidateCell: true
                            };
                        }

                        break;

                    
                }

                return {
                    _pending: false,
                    value: calculatedValue,
                    invalidateCell: false
                };

                
            } catch (ex) {
                this.UiModder.domClass.add(targetCell.node, "warningBG");

                ToasterHelpers.showToast({
                    title: "error calculating summary cell value " + targetCell.cellID,
                    message: ex,
                    iconClass: toasterIcons.error,
                    timeout: 15000
                });

                return {
                    _pending: false,
                    value: undefined,
                    invalidateCell: true
                };
            }

        }

        return undefined;
    }

    
    private _asyncCalculationQueue: Array<AsyncCalculationQueueEntry<T>>;
    private _asyncCalculationTimeout;

    private _addCellToAsyncCalculation(cell: SpreadsheetTableTypes.TableCell, triggeringCell: SpreadsheetTableTypes.TableCell): boolean {

        if (!cell) return false;

        if (this._asyncCalculationTimeout) clearTimeout(this._asyncCalculationTimeout);
        this._asyncCalculationTimeout = null;

        let queueEntry = this._asyncCalculationQueue.filter(entry => entry.status == "pending")[0];
        let otherEntries = this._asyncCalculationQueue.filter(entry => entry.status != "pending");

        if (!queueEntry) {
            queueEntry = {
                status: "pending",
                cells: {},
                transactionID: null,
            };
        }

        let rowID: string = null;
        let rowIDtrigger: string = null;

        if (this.isDataCell(cell)) {
            let dataCell = cell as SpreadsheetTableTypes.DataCell;
            rowID = dataCell.row.rowID;
        }
        if (this.isDataCell(triggeringCell)) {
            let dataCell = triggeringCell as SpreadsheetTableTypes.DataCell;
            rowIDtrigger = dataCell.row.rowID;
        }

        this.UiModder.domClass.add(cell.node, "calculationPending"); // ist sie eigentlich schon...

        queueEntry.cells[cell.cellID] = {
            triggeringCell: {
                cellID: triggeringCell.cellID,
                columnID: triggeringCell.column.columnID,
                displayValue: triggeringCell.displayValue,
                value: triggeringCell.value,
                rowID: rowIDtrigger
            },
            cellID: cell.cellID,
            columnID: cell.column.columnID,
            rowID: rowID,
            value: cell.value,
            displayValue: cell.displayValue
        };

        this._asyncCalculationQueue = [];
        this._asyncCalculationQueue.push(queueEntry);
        this._asyncCalculationQueue = this._asyncCalculationQueue.concat(otherEntries);

        this._asyncCalculationTimeout = setTimeout(lang.hitch(this, this._handleAsyncCalculationQueue), 500)
    }

    private _handleAsyncCalculationQueue() {
        let pendingEntries = this._asyncCalculationQueue.filter(entry => entry.status == "pending");
        if (!pendingEntries.length) return;

        let requestData: SpreadsheetTableTypes.AsyncCellCalculationRequest = {
            transactionID: StringHelpers.randomID(8),
            pendingCells: []
        };

        let allCells: Record<string, any> = {}; // um Dubletten zu vermeiden machen wir einen Gesamtrecord        
        for (let entry of pendingEntries) {
            entry.status = "running";
            entry.transactionID = requestData.transactionID;

            for (let key in entry.cells) {
                allCells[key] = entry.cells[key];
            }
        }
        
        let success: boolean = true;

        for (let key in allCells) {
            requestData.pendingCells.push(allCells[key]);
        }

        if (!this._config.asyncCellCalculationFct) {
            console.warn(this.id + ": no callback for calculating cell values!");

            pendingEntries.forEach(entry => entry.status = "cancelled");
            success = false;
        } else {
            try {
                this._config.asyncCellCalculationFct(requestData);
            } catch (ex) {
                success = false;

                ToasterHelpers.showToast({
                    title: "error calculating cell values",
                    message: ex,
                    iconClass: toasterIcons.error,
                    timeout: 15000
                });

                console.error(this.id + ": error calculating cell values", ex.message);

                pendingEntries.forEach(entry => entry.status = "error");
            }
        }

        if (!success) {
            for (let key in allCells) {
                let cell = this.getCellById(key);
                if (cell) {
                    this.UiModder.domClass.toggle(cell.node, "calculationError", true);
                }
            }
        }
    }

    setCalculationQueueResults(transactionID: string, results: Array<SpreadsheetTableTypes.AsyncCellCalculationResponse> | false) {
        if (!transactionID) return;

        let queueEntries = this._asyncCalculationQueue.filter(entry => entry.transactionID == transactionID);

        queueEntries.forEach(entry => entry.status = results == false ? "error" : "done");
        queueEntries.forEach(entry => entry.results = []);

        if (results != false) {
            
        }

        if (results === false) {

        } else {
            for (let entry of queueEntries) {
                for (let cellID in entry.cells) {
                    let filtered = results.filter(entry => entry.cellID == cellID);

                    for (let filteredResult of filtered) {
                        entry.results.push(filteredResult);
                    }
                }
            }

            for (let entry of results) {
                let cell = this.getCellById(entry.cellID);

                if (cell && cell.pendingValue) {
                    this._setCellValue(cell, entry.value, null, null);
                    this.UiModder.domClass.remove(cell.node, "calculationPending");
                }
            }
        }


    }

    private _getSumValue(targetCell: SpreadsheetTableTypes.SummaryCell): number {
        if (!targetCell) {
            return 0;
        }
        let col = this.getColumn(targetCell);// this.tableData.columns[targetCell.sourceCol.columnID];
        let sum: number = 0;
        for (let key in col.cells) {
            let cellInCol = col.cells[key];

            switch (cellInCol.column.valueType) {
                case "int":
                case "float":
                case "currency":
                    if (typeof cellInCol.value == "number") {
                        sum += cellInCol.value;
                    }
                    break;

                
            }
        }

        return sum;
    }


    isDataRow(unknown): boolean {
        let result = this.getRow(unknown) as SpreadsheetTableTypes.DataRow<T>;
        if (result && result.cells && result.rowID) {
            return true;
        }
    }

    getRow(datacell: SpreadsheetTableTypes.DataCell): SpreadsheetTableTypes.DataRow<T>
    getRow(summarycell: SpreadsheetTableTypes.SummaryCell): SpreadsheetTableTypes.SummaryRow<T>
    getRow(cell: SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.TableRow<T>
    getRow(rowID: string): SpreadsheetTableTypes.TableRow<T>
    getRow(row: SpreadsheetTableTypes.TableRow): SpreadsheetTableTypes.TableRow<T>
    getRow(value: string | SpreadsheetTableTypes.TableRow | SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.TableRow<T> {
        if (!value) return null;

        if (this.isDataCell(value) || this.isSummaryCell(value)) {
            let cell = this.getCell(value as any) as SpreadsheetTableTypes.TableCell;
            return cell.row;
        }

        if (typeof value == "string") {
            return this.tableData.rows[value];
        } else if (typeof value == "object") {
            let row = value as SpreadsheetTableTypes.TableRow;
            if (row.cells) return row;
        }
    }
   
    getRowDataEntity(cell: SpreadsheetTableTypes.TableCell): T
    getRowDataEntity(row: SpreadsheetTableTypes.DataRow): T 
    getRowDataEntity(rowID: string): T
    getRowDataEntity(any): T {
        let row = this.getRow(any);
        if (!row) {

        } else {
            let rowID = row.rowID;
            return this.dataStore.getEntityById(rowID);
        }

        return null;
    }
    //setColumnHead(columnID: string, newContent: string | HTMLElement | { heading: string, infoText?: string }) {
    //    if (!columnID) return;
    //    let col = this.tableData.columns[columnID];
    //    if (!col) return;

    //    col.no
    //}

    // Todo: ID-Werte auch zulassen
    addAction(column: SpreadsheetTableTypes.Column, internalName: string, config: SpreadsheetTableTypes.ColumnActionDescriptor)
    addAction(row: SpreadsheetTableTypes.TableRow, internalName: string, config: SpreadsheetTableTypes.RowActionDescriptor)
    addAction(cell: SpreadsheetTableTypes.DataCell, internalName: string, config: SpreadsheetTableTypes.CellActionDescriptor)
    addAction(target, internalName: string, config) {
        if (!target || !config) return;
        
        if (typeof target == "object") {
            
            let existingAction = target.actions[internalName];
            if (existingAction) return; // vorerst raus. todo: Aktion ersetzen?
            target.actions[internalName] = {
                ...config,
                button: null
            };

            this._drawActions(target);
        }
    }
    getColumnNames(): Array<string> {
        let colArray = this.getColumns();
        let result = colArray.map(col => col.columnID);

        return result;
    }

    getColumns(): Array<SpreadsheetTableTypes.Column<T>> {
        let result = [];
        for (let key in this.tableData.columns) {
            result.push(this.tableData.columns[key]);
        }

        // jetzt erst dieses Array sortieren nach der internen order
        result.sort((col1, col2) => col1.order - col2.order);

        return result;
    }
    getRows(): Array<SpreadsheetTableTypes.DataRow<T>> {
        let result = [];
        for (let key in this.tableData.rows) {
            result.push(this.tableData.rows[key]);
        }

        return result;
    }
    getColumn(columnID: string): SpreadsheetTableTypes.Column<T>
    getColumn(unknown: SpreadsheetTableTypes.Column | SpreadsheetTableTypes.TableCell | string): SpreadsheetTableTypes.Column<T>
    getColumn(column: SpreadsheetTableTypes.Column): SpreadsheetTableTypes.Column<T>
    //getColumn(cell: SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.Column<T>
    getColumn(cell: SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.Column<T>
    getColumn(ref: string | SpreadsheetTableTypes.TableCell | SpreadsheetTableTypes.Column): SpreadsheetTableTypes.Column<T> {
        let cell = ref as SpreadsheetTableTypes.TableCell;
        let summaryCell = ref as SpreadsheetTableTypes.SummaryCell;
        let col = ref as SpreadsheetTableTypes.Column;
        let colId = ref as string;

        if (!ref) return null;

        if (this.isDataCell(cell) || this.isSummaryCell(cell)) {
            colId = cell.column.columnID;
        } else if (col.columnID) {
            colId = col.columnID;
        }

        if (colId) {
            return this.tableData.columns[colId];
        }

    }
    getCellById(cellID: string): SpreadsheetTableTypes.DataCell<T> {
        if (this.cells[cellID]) return this.cells[cellID];

        return null;

    }

    //getSummaryCells(row: SpreadsheetTableTypes.DataRow<T>): Array<SpreadsheetTableTypes.SummaryCell<T>> // macht wenig Sinn...
    getSummaryCells(column: SpreadsheetTableTypes.Column<T>): Array<SpreadsheetTableTypes.SummaryCell<T>>
    getSummaryCells(cell: SpreadsheetTableTypes.TableCell<T>): Array<SpreadsheetTableTypes.SummaryCell<T>>
    getSummaryCells(unknown): Array<SpreadsheetTableTypes.SummaryCell<T>> {

        if (this.isColumn(unknown)) {
            let result = [];
            let col = this.getColumn(unknown);
            if (!col) return result;

            for (let key in col.summaryCells) {
                result.push(col.summaryCells[key]);
            }

            return result;
        }
        else if (this.isDataCell(unknown)) {
            let cell = this.getCell(unknown);
            if (!cell) return [];

            let col = cell.column;
            return this.getSummaryCells(col);
        }
        else if (this.isDataRow(unknown)) {
            let row = this.getRow(unknown);
            if (!row) return [];

        }

    }
    getSummaryCell(cell: SpreadsheetTableTypes.TableCell<T>): SpreadsheetTableTypes.SummaryCell<T>
    getSummaryCell(cellID: string): SpreadsheetTableTypes.SummaryCell<T>
    getSummaryCell(param1): SpreadsheetTableTypes.SummaryCell<T> {
        let cell = this.getCell(param1);

        if (this.isSummaryCell(cell)) return cell as SpreadsheetTableTypes.SummaryCell<T>;
    }

    getCell(cellID: string): SpreadsheetTableTypes.TableCell<T>
    getCell(cell: SpreadsheetTableTypes.TableCell): SpreadsheetTableTypes.TableCell<T>
    getCell(row: SpreadsheetTableTypes.TableRow, columnID: string): SpreadsheetTableTypes.TableCell<T>
    getCell(row: SpreadsheetTableTypes.TableRow, column: SpreadsheetTableTypes.Column): SpreadsheetTableTypes.TableCell<T>
    getCell(rowID: string, columnID: string): SpreadsheetTableTypes.TableCell<T>
    getCell(rowID: string, column: SpreadsheetTableTypes.Column): SpreadsheetTableTypes.TableCell<T>
    getCell(unknown: string | SpreadsheetTableTypes.TableRow | SpreadsheetTableTypes.TableCell, unknown2?: string | SpreadsheetTableTypes.Column): SpreadsheetTableTypes.TableCell<T> {

        if (!unknown) return null;

        let row: SpreadsheetTableTypes.TableRow;
        let col: SpreadsheetTableTypes.Column;

        
        // unknown2 is colID oder schon die column:
        if (!!unknown2) {
            col = this.getColumn(unknown2);
        }
        
        if (typeof unknown == "string") {
            // cellID?
            let cell = this.getCellById(unknown);
            if (cell) return cell;

            // cell wars nicht. rowID?
            let rowID = unknown;
            row = this.getRow(rowID);
        }
        else if (this.isDataCell(unknown) || this.isSummaryCell(unknown)) {
            return unknown as SpreadsheetTableTypes.TableCell;
        } else if (typeof unknown == "object" && !!unknown2) {
            // unknown ist tablerow
            row = unknown as SpreadsheetTableTypes.TableRow;
                    
        }

        if (row && col) {
            let cells = this.getCells(row);

            if (cells.length) {
                for (let cell of cells) {
                    if ((cell as SpreadsheetTableTypes.SummaryCell).column.columnID == col.columnID) return cell;
                }
            }
               
        }

        return null;
    }

    getCells(columnID: string): Array<SpreadsheetTableTypes.TableCell<T>>
    getCells(column: SpreadsheetTableTypes.Column): Array<SpreadsheetTableTypes.TableCell<T>>
    getCells(rowID: string): Array<SpreadsheetTableTypes.TableCell<T>>
    getCells(row: SpreadsheetTableTypes.TableRow): Array<SpreadsheetTableTypes.TableCell<T>>
    getCells(): Array<SpreadsheetTableTypes.DataCell<T>>
    getCells(param1?: string | SpreadsheetTableTypes.TableRow<T> | SpreadsheetTableTypes.Column<T>): Array<SpreadsheetTableTypes.TableCell<T>> {
        let result = [];

        let _col: SpreadsheetTableTypes.Column;
        let _row: SpreadsheetTableTypes.TableRow;

        _row = this.getRow(param1 as any);
        _col = this.getColumn(param1 as any);
        

        let cells: Record<string, SpreadsheetTableTypes.TableCell>;
        if (_row) cells = _row.cells;
        if (_col) cells = _col.cells;

        if (!param1) {
            cells = this.cells;
        }

        if (cells) {
            for (let key in cells) {
                let cell = cells[key];
                result.push(cell);
            }
        }

        

        return result;
    }

    //private _onStoreEntityChange(changedEntry: T) {
    //    if (!this.isReadonly) {
    //        let dataID = EntityHelpers.getComplexProperty(changedEntry, this.dataStore.keyAttribute);
    //        let cell = this.getCell(dataID)
    //    }
    //}
    private _onClick_Cell(cell: SpreadsheetTableTypes.DataCell, evt?: PointerEvent) {
        if (cell.isEditing || this.isGlobalEditingMode) return;
        if (this.isReadonly) return;
        if (!cell.editable) return;

        evt.preventDefault();
        evt.stopPropagation();

        this._setCellEditing(cell, true);
    }
    private _onClick_CancelCellEditing(cell: SpreadsheetTableTypes.DataCell, evt: PointerEvent) {
        
        evt.preventDefault();
        evt.stopPropagation();
        
        this.cancelCellValueChange(cell);
    }
    private _onClick_SubmitCellValue(cell: SpreadsheetTableTypes.DataCell, evt: PointerEvent) {
        if (this.isReadonly) return;
        if (cell.isEditing != true || cell.editable != true) return;
        evt.preventDefault();
        evt.stopPropagation();
        this.commitCellValueChange(cell);
    }
    private _onCellInputChange(cell: SpreadsheetTableTypes.DataCell) {
        if (this.isReadonly) return;
        if (cell.isEditing != true || cell.editable != true) return;
        if (this.isGlobalEditingMode) this.commitCellValueChange(cell);
    }

    private cancelCellValueChange(cell: SpreadsheetTableTypes.DataCell) {
        this._setCellEditing(cell, false);

        //this._createCellInput(cell); // einfach neu machen.
    }
    private commitCellValueChange(cell: SpreadsheetTableTypes.DataCell) {
        if (cell.editable != true) {
            cell.value = cell.originalValue;
            this._setCellEditing(cell, false);
            return;
        }

        let input = cell.input as MdsLax<InstanceType<typeof _StatefulBase>>;

        let newValue: any = cell.value;
        switch (cell.column.valueType) {
            case "int":
            case "float":
            case "currency":
                input = cell.input as MdsLax<InstanceType<typeof NumberInput>>;
                newValue = input.getValue();
                break;
            case "percent":
                input = cell.input as MdsLax<InstanceType<typeof NumberInput>>;
                newValue = input.getValue();
                if (typeof newValue == "number") {
                    newValue = newValue / 100;
                }
                break;
            case "text":
            case "textMultiline":
                input = cell.input as MdsLax<InstanceType<typeof moreCoreEdit>>;
                newValue = input.getValue();
                break;
            case "bool":
            case "tristate":
                input = cell.input as MdsLax<InstanceType<typeof RadioGroup>>;
                newValue = input.getValue();
                break;

            default:
                this._setCellEditing(cell, this.isGlobalEditingMode);
                break;
        }
        
        this._setCellValue(cell, newValue);      
        
        this._setCellEditing(cell, this.isGlobalEditingMode);
    }

    private _defaultFormatters: Record<SpreadsheetTableTypes.valueType, SpreadsheetTableTypes.formatterFct> = {
        "currency": (this as any)._defaultFormatterNumbers,
        "percent": (this as any)._defaultFormatterNumbers,
        "int": (this as any)._defaultFormatterNumbers,
        "float": (this as any)._defaultFormatterNumbers,
        "bool": (this as any)._defaultFormatterBool,
        "tristate": (this as any)._defaultFormatterBool,
        "text": null,
        "empty": function (value, cell) { return ""; },
        "textMultiline": null,
        //"custom": null        ,
        //"formula": null        
    }

    private _defaultFormatterNumbers(value: number, cell: SpreadsheetTableTypes.TableCell) {

        let dsp = "";
        let valueType = cell.column.valueType;

        let sumCell = this.getSummaryCell(cell);
        
        if (sumCell) {
            valueType = sumCell.summaryDescriptor?.valueType ? sumCell.summaryDescriptor.valueType : valueType;
        }
        
        if (typeof value == "string") dsp = value;

        switch (valueType) {
            case "int":
                if (typeof value == "number") {
                    if (cell.reverseValueSign) {
                        value = value * -1;
                    }
                    dsp = value.toFixed(0);
                }
                break;
            case "float":
                if (typeof value == "number") {
                    if (cell.reverseValueSign) {
                        value = value * -1;
                    }
                    dsp = StringHelpers.numberToString(value, 1, cell.column.places ? cell.column.places : 2);
                }
                break;
            case "currency":
                let unit = "€";
                if (cell.column?.unitLabel) {
                    unit = cell.column.unitLabel;
                    
                }
                
                // Leerzeichen am Ende normalisieren auf 1:
                unit.trimEnd();
                unit += "&nbsp;";

                if (typeof value == "number") {
                    if (cell.reverseValueSign) {
                        value = value * -1;
                    }
                    dsp = unit + StringHelpers.numberToString(value, 1, 2);
                } else {
                    dsp = unit + "-,--";
                }
                break;
            case "percent":
                if (typeof value == "number") {
                    value = value * 100;
                    if (cell.reverseValueSign) {
                        value = value * -1;
                    }
                    dsp = StringHelpers.numberToString(value, 1, cell.column.places ? cell.column.places : 1) + "%";
                } else {
                    dsp = "-%";
                }
                break;
        }
       

        
        return dsp;
    }

    private _defaultFormatterBool(value: boolean) {
        let icon: HTMLElement = null;
        switch (value) {
            case true:
                icon = HtmlHelpers.createFontawesomeIcon("fas fa-check border paddingSmall brightTransparentBG");
                break;
            case false:

                icon = HtmlHelpers.createFontawesomeIcon("fas fa-times border paddingSmall brightTransparentBG");
                break;
            default:
                icon = HtmlHelpers.createFontawesomeIcon("fas fa-minus-circle border paddingSmall brightTransparentBG");
                break;
        }

        return icon.outerHTML;
    }

    private _currentEditingCell;
    private _setCellEditing(cell: SpreadsheetTableTypes.DataCell, bSetEditing: boolean, overrideIfNotEditable?: boolean) {
        let bActualTarget = bSetEditing == true;
        if (!cell.editable && overrideIfNotEditable !== true) bSetEditing = false;
        if (cell.column.valueType == "empty") bSetEditing = false;
        if (this.isReadonly) bActualTarget = false;
        if (this.isGlobalEditingMode) bActualTarget = true;

        cell.isEditing = bActualTarget;

        this.UiModder.domClass.toggle(cell.node, "editing", cell.isEditing == true);

        if (!cell.isEditing) this._currentEditingCell = null;

        if (!cell.input && cell.isEditing) {

            if (this._currentEditingCell && !this.isGlobalEditingMode) {
                this._setCellEditing(this._currentEditingCell, false);
            }
            if (!this.isGlobalEditingMode) this._currentEditingCell = cell;

            this.UiModder.domConstruct.empty(cell.editContainerNode);

            this._createCellInput(cell);

            if (!this.isGlobalEditingMode) {
                let btnGroup = this.UiModder.domConstruct.create("div", {
                    className: "cellEditButtons buttonGroup justify_right flex_cell_rest"
                }, cell.editContainerNode);

                //if (cell.input) {
                //    cell.input.placeAt(btnGroup);
                //}

                let btnCommit = new Button();
                btnCommit.setup({
                    iconLeft: "fas fa-check",
                    styleClass: "smallBtn okBtn",
                    parentNode: btnGroup,
                    callback: lang.hitch(this, this._onClick_SubmitCellValue, cell)
                });

                let btnCancel = new Button();
                btnCancel.setup({
                    iconLeft: "fas fa-times",
                    styleClass: "smallBtn",
                    parentNode: btnGroup,
                    callback: lang.hitch(this, this._onClick_CancelCellEditing, cell)
                });

                if (cell.input) {
                    try {
                        let input = cell.input as MdsLax<InstanceType<typeof _ControlBase>>;
                        if (input.focus) input.focus();
                    } catch (ex) {

                    }
                }
            }
        }

        if (cell.isEditing && !this.isGlobalEditingMode) {
            this._handleActionStatus(cell, null, false);
        }

        if (!cell.isEditing) {
            this._handleActionStatus(cell);
        }

        if (!cell.isEditing && cell.input) {
            try {
                if (!cell.input._destroyed) {
                    cell.input.destroy();
                }
            } catch (ex) {

            }
            if (cell.actionContainerNode) {
                this.UiModder.domConstruct.empty(cell.actionContainerNode);
            }
            cell.input = null;
        }
    }

    private isColumn(unknown): boolean {
        let col = unknown as SpreadsheetTableTypes.Column;
        if (!unknown) return false;
        if (col.columnID) return true;
        return false;
    }
    private isDataCell(unknown): boolean {
        let dataCell = unknown as SpreadsheetTableTypes.DataCell;
        if (!unknown) return false;
        if (typeof dataCell.dirty == "boolean") return true;
        return false;
    }
    private isSummaryCell(unknown): boolean {
        if (this.isDataCell(unknown)) return false;
        let sumCell = unknown as SpreadsheetTableTypes.SummaryCell;
        if (!unknown) return false;
        if (typeof sumCell.column == "object" && typeof sumCell.summaryDescriptor == "object") return true;
        return false;
    }

    private formatCellValue(cell: SpreadsheetTableTypes.TableCell) {
        let summaryCell = this.getSummaryCell(cell);
        let valueType = cell.column.valueType;

        this.UiModder.domClass.toggle(cell.node, "invalid", cell.valid === false);
        this.UiModder.domClass.toggle(cell.node, "calculationPending", cell.pendingValue === true);
        
        if (summaryCell?.summaryDescriptor?.valueType) valueType = summaryCell.summaryDescriptor.valueType;

        if (cell.column.formatterFct) {
            cell.displayValue = cell.column.formatterFct(cell.value, cell)
        } else {
            let formatter = this._defaultFormatters[cell.column.valueType];
            if (formatter) {
                let hitched = lang.hitch(this, formatter);
                cell.displayValue = hitched(cell.value, cell);
            }
            else if (cell.value?.toString) {
                cell.displayValue = cell.value.toString();
            } else if (typeof (cell.value) == "string") {
                cell.displayValue = cell.value;
            }
        }

        if (typeof (cell.displayValue) == "undefined") {
            cell.displayValue = "";
        }

        cell.displayValueNode.innerHTML = cell.displayValue;
        
        this._handleStyleFormatter(cell);


    }
    //private _setCellInvalid(cell: SpreadsheetTableTypes.TableCell, bSetInvalid: boolean = true) {
    //    if (this.isDataCell(cell)) {
    //        let dataCell: SpreadsheetTableTypes.DataCell<T> = cell as any;

    //        dataCell.valid = bSetInvalid !== false;

    //        this.formatCellValue(cell);
    //    }
    //}

    invalidateCell(cells: SpreadsheetTableTypes.TableCell[], bInvalidate?: boolean)
    invalidateCell(cell: SpreadsheetTableTypes.TableCell, bInvalidate?: boolean)
    invalidateCell(param, bInvalidate: boolean = true) {
        if (lang.isArray(param)) {
            for (let cell of param) {
                this.invalidateCell(cell, bInvalidate);
            }
        } else if (param) {
            let cell = param as SpreadsheetTableTypes.TableCell;

            param.valid = bInvalidate === false;
            this._handleCellValidation(cell, true);
        }
    }

    private _handleCellValidation(cell: SpreadsheetTableTypes.TableCell, skipValidation?: boolean) {

        if (typeof cell.valid != "boolean") {
            if (cell.column.validationFct && skipValidation !== true) {
                cell.valid = cell.column.validationFct(cell.value, cell)
            } else {
                cell.valid = true; // wird schon passen...
            }
        }

        this.formatCellValue(cell);

    }

    private _onStoreChange_Entity(data) {
        if (!this.isReadonly && this._startupState == "ready") {
            let rowID = data[this.dataStore.keyAttribute];
            let row = this.getRow(rowID) as SpreadsheetTableTypes.DataRow<T>;
            row.data = data;
            this.emit("rowChanged", row);
        }
    }
    private _onStoreChange() {
        if (!this.isReadonly && this._startupState == "ready") {
            //this.enableButton("save", this.dataStore.isDirty());
            this.emit("change");
            this.emit("dirty", this.dataStore.isDirty());
        }
    }

    //private _onClickSaveButton(evt: MouseEvent) {
    //    let diffData = this.dataStore.getDiffData();
    //    let changedData = {};
    //    if (diffData) changedData = { dataList: diffData.changed, valueAttribute: this.colValueAttribute };


    //    this.emit("saved", { dataElement: this.originalEntity, changedData: changedData });
    //    this.close();
    //}

    private _createSummaryRow(): SpreadsheetTableTypes.SummaryRow<T> {
        let sumRow: SpreadsheetTableTypes.SummaryRow = {
            //rowID: "xxx",
            label: null,
            infoText: null,
            node: null,
            labelNode: null,
            infoTextNode: null,
            actionContainerNode: null,
            actionContainerNodePrimary: null,
            actions: {},
            cells: {},
            collapsed: false,
            collapsible: false
        };

        let rowNode = this.UiModder.domConstruct.create("tr", {
            className: "summaryRow"
        }, this.tableData.node, "last");

        let firstCol = this.UiModder.domConstruct.create("th", {
            className: "rowLabelColumn",
            innerHTML: ""
        }, rowNode);
        this.UiModder.domConstruct.create("div", {
            className: "_emptyCell w3-hide"
        }, firstCol);

        sumRow.node = rowNode;
        let index = Object.keys(this.tableData.summaryRows).length;
        this.tableData.summaryRows[index] = sumRow;

        // für jede Spalte gehört eine Zelle - auch wenns keine Summe gibt!
        let sortedColumns = this.getColumns();
        for (let col of sortedColumns) {
            let colID = col.columnID;
            let cell: SpreadsheetTableTypes.SummaryCell = {
                cellID: colID + ":sum-" + index,
                node: null,
                innerNode: null,
                dependencies: [],
                column: col,
                summaryDescriptor: null,
                row: sumRow,
                value: null,
                actions: {},
                reverseValueSign: false
            };

            this._checkReverseSign(cell);

            sumRow.cells[colID] = cell;

            this._drawSummaryCell(cell);
        }

        return sumRow;
    }

    addRow(data?: Partial<T>, placeAtRowId?: string, placement?: "before" | "after") {
        this.createDataRow(data, placeAtRowId, placement);
    }
    createDataRow(data?: Partial<T>, placeAtRowId?: string, placement?: "before" | "after"): SpreadsheetTableTypes.TableRow {

        let entry = {} as any as T;

        if (data) {
            entry = lang.clone(data as any);
        }
        let dataClone = data;
        let dataID = data[this._config.rowIdAttribute ? this._config.rowIdAttribute : "ID"];

        if (!this.isReadonly && this.dataStore) {
            dataID = this.dataStore.addEntry(entry ? entry : {} as T);
            dataClone = this.dataStore.getEntityById(dataID);
        }
        let existingRow = this.tableData.rows[dataID];
        if (existingRow) {
            try {
                // aus Registry der descriptors entfernen
                let colArray = this.getColumns();
                for (let col of colArray) {
                    col.cells[dataID] = null;
                }
                this.UiModder.domConstruct.destroy(existingRow.node);
                
            } catch (ex) {

            }
        }


        let row: SpreadsheetTableTypes.DataRow = {
            cells: {},
            rowID: dataID,
            actions: {},
            labelNode: null,
            infoTextNode: null,
            actionContainerNode: null,
            actionContainerNodePrimary: null,
            node: null,
            data: dataClone,
            virtual: this.dataStore.isEntityNew(dataID),
        };

        if (this._config.rowStyleFormatter) row.rowStyleFormatter = this._config.rowStyleFormatter;

        if (this.tableData.rowActions) {
            for (let actionName in this.tableData.rowActions) {
                let action = this.tableData.rowActions[actionName];
                row.actions[actionName] = {
                    ...action,
                    button: null
                };
            }
        }

        if (this.tableData.rowLabelAttribute) {
            let dataLabel = EntityHelpers.getComplexProperty(dataClone, this.tableData.rowLabelAttribute);
            row.label = dataLabel;
        }

        let parentNode: HTMLElement = null;
        if (placeAtRowId) {
            let row = this.tableData.rows[placeAtRowId];
            if (row) parentNode = row.node;
        }

        if (!parentNode) {
            parentNode = this.tableData.node;
            placement = null;
        }
        else if (!placement) placement = "after";


        this.tableData.rows[dataID] = row;

        this._drawRow(row, parentNode, placement);

        

        // Abhängigkeiten durch Formeln hinterlegen - jetzt ist ja alles angelegt
        let colArray = this.getColumns();
        for (let col of colArray) {
            let columnID = col.columnID;

            if (col.formula) {
                // die Zelle aus der Reihe holen, die in der Formel referenziert wird:
                for (let refColumn of col.formula.triggeringColumns) {
                    let calculationSourceCell = this.getCell(row.rowID, refColumn.columnID);

                    // die Zelle, die laut columndescriptor erzeugt worden ist und die diese formula verwenden wird:
                    let dependentCell = this.getCell(row.rowID, columnID);

                    if (calculationSourceCell && dependentCell) {
                        calculationSourceCell.dependencies.push({ cell: dependentCell });

                        this.UiModder.domClass.add(dependentCell.node, "calculated");

                        if (typeof dependentCell.value == "undefined" || dependentCell.value == null) {
                            this._addCellToCalculationQueue(dependentCell, dependentCell.value, calculationSourceCell);
                        }
                    }
                }

            }
        }

        return row;
    }

    private _createSummaries() {
        let colArray = this.getColumns();
        for (let col of colArray) {

            let colID = col.columnID;

            if (col.summaryDescriptors?.length) {

                let index = -1;
                // Summenzeilen und sonstige Zusammenfassungen behandeln
                // die Descriptors werden zu Zellen, also müssen sie untereinander stehen
                for (let summaryDescriptor of col.summaryDescriptors) {
                    index++;

                    if (!summaryDescriptor.styleFormatter && this._config.summaryCellsFormatter) {
                        summaryDescriptor.styleFormatter = this._config.summaryCellsFormatter;
                    }

                    // pro summary benötigen wir eine komplette Zeile (Row)
                    // je nachdem ob eine SPALTE mehrere Summaries hat, benötigt sie womöglich zusätzliche Rows oder kann eine bestehende noch mitverwenden
                    let existingSummaryRow = this.tableData.summaryRows[index];
                    if (!existingSummaryRow) {
                        existingSummaryRow = this._createSummaryRow(); // die Cells sind dann schon vorbereitet - aber unused, ohne descriptor
                    }
                    if (existingSummaryRow) {
                        let cell = this.getCell(existingSummaryRow, colID) as SpreadsheetTableTypes.SummaryCell;
                        cell.summaryDescriptor = summaryDescriptor;
                        this._drawSummaryCell(cell);
                        col.summaryCells[index] = cell;
                    }
                }
            }

        }
    }

    protected onDirtyChange(newState: boolean) {
        
    }

    private _createCellInput(cell: SpreadsheetTableTypes.DataCell) {
        let colDescriptor = cell.column;

        switch (colDescriptor.valueType) {
            case "text":
            case "textMultiline":
                let edit = new moreCoreEdit();

                if (colDescriptor.valueType == "textMultiline") {
                    edit.setIsMultiline(true);
                }

                let strVal = cell.value as string;
                edit.setValue(strVal, true);

                cell.input = edit;
                break;

            case "int":
            case "float":
                let numberInput = new NumberInput();
                numberInput.setRestrictToAbsoluteValue(false);
                if (colDescriptor.valueType == "float") {
                    if (colDescriptor.places > 0) numberInput.setPlaces(colDescriptor.places);
                }

                if (colDescriptor.unitLabel) {
                    numberInput.setUnit(colDescriptor.unitLabel);
                }

                let numVal = cell.value as number;

                numberInput.setReverseValueSign(cell.reverseValueSign === true);
                numberInput.setShowCalculator(cell.editable == true);

                numberInput.setValue(numVal, true);

                cell.input = numberInput;
                break;

            case "currency":
            case "percent":
                let currencyInput = new NumberInput();
                currencyInput.setNumberType(colDescriptor.valueType);
                currencyInput.setRestrictToAbsoluteValue(false);
                
                let curVal = cell.value as number;

                if (typeof (curVal) == "number" && colDescriptor.valueType == "percent") {
                    curVal = curVal * 100;
                }

                currencyInput.setReverseValueSign(cell.reverseValueSign === true);
                currencyInput.setShowCalculator(cell.editable == true);

                currencyInput.setValue(curVal, true);

                cell.input = currencyInput;
                break;
            case "bool":
            case "tristate":
                let rg = new RadioGroup({
                    alignment: "verticalRight",
                    paddings: "default",
                    value: cell.value,
                    entries: [{
                        value: true,
                        label: "General_Label_Yes"
                    },{
                        value: false,
                        label: "General_Label_No"
                    }]
                });

                if (colDescriptor.valueType == "tristate") {
                    rg.addEntry(null, "General_Label_NoSelection");
                }

                cell.input = rg;
                break;
            default:
                return;
                break;
        }

        if (cell.input) {
            if (cell.input.placeAt) {
                let cellInputContainer = this.UiModder.domConstruct.create("div", {
                    className: "inputContainer"
                }, cell.editContainerNode);

                cell.input.placeAt(cellInputContainer, "only");
            }
            cell.input.on("change", lang.hitch(this, this._onCellInputChange, cell));
        }
    }

    private _checkReverseSign(cell: SpreadsheetTableTypes.TableCell) {
        let colDescriptor = cell.column;

        if (this.isDataCell(cell)) {
            let dataCell = cell as SpreadsheetTableTypes.DataCell;
            let entity = this.dataStore.getEntityById(dataCell.row.rowID);

            if (colDescriptor.reverseSignAttribute) {
                let result = false;
                let propValue = EntityHelpers.getComplexProperty(entity, colDescriptor.reverseSignAttribute);
                switch (typeof propValue) {
                    case "boolean":
                        result = propValue === true;
                        break;

                    case "string":
                        result = colDescriptor.reverseSignValue ? propValue == colDescriptor.reverseSignValue : !!propValue;
                        break;

                    case "number":
                        propValue = propValue.toString();
                        result = colDescriptor.reverseSignValue ? propValue == colDescriptor.reverseSignValue : !!propValue;
                        break;
                }

                cell.reverseValueSign = result;
            }
        } else if (this.isSummaryCell(cell)){
            let sumCell = cell as SpreadsheetTableTypes.SummaryCell;
            let result = sumCell.summaryDescriptor?.reverseSign == true;

            sumCell.reverseValueSign = result;
        }

    }

    private _drawColHead(col: SpreadsheetTableTypes.Column) {

    }
    private _drawCell(cell: SpreadsheetTableTypes.DataCell): HTMLElement {
        let cellNode = this.UiModder.domConstruct.create("td", {
            className: "dataCell",
            "data-column-id": cell.column.columnID,
            "data-cell-id": cell.cellID
        }, cell.row.node);

        let cellInnerNode = this.UiModder.domConstruct.create("div", {
            className: "innerContainer"
        }, cellNode);

        
        let cellEditContainer = this.UiModder.domConstruct.create("div", {
            className: "editContainer"
        }, cellInnerNode);
        on(cellEditContainer, "keyup", lang.hitch(this, this._onKeyUpEditContainer, cell));

        let cellValueGroup = this.UiModder.domConstruct.create("div", {
            className: "valueGroup"
        }, cellInnerNode);

        // brauchen wir für Markierungen mit aria-hidden
        this.UiModder.domConstruct.create("span", {
            className: "symbolContainer",
            "aria-hidden": "true"
        }, cellInnerNode, "first");

        let cellValueContainer = this.UiModder.domConstruct.create("div", {
            className: "valueContainer"
        }, cellValueGroup);

        
        let unitContainer = this.UiModder.domConstruct.create("div", {
            className: "unitContainer",
            innerHTML: cell.column.unitLabel && cell.column.valueType != "currency" ? cell.column.unitLabel : ""
        }, cellValueGroup);

        let cellInfoContainer = this.UiModder.domConstruct.create("div", {
            className: "infoContainer"
        }, cellInnerNode);

        let actionsContainerPrimary = this.UiModder.domConstruct.create("div", {
            className: "actionContainer primary"
        }, cellInnerNode);

        let actionsContainer = this.UiModder.domConstruct.create("div", {
            className: "actionContainer"
        }, cellInnerNode);

        if (cell.actions) {
            this._drawActions(cell);
        }


        cell.node = cellNode;
        cell.innerNode = cellInnerNode;
        cell.unitLabelNode = unitContainer;
        cell.displayValueNode = cellValueContainer;
        cell.editContainerNode = cellEditContainer;
        //cell.inputContainerNode = cellInputContainer;
        cell.infoTextNode = cellInfoContainer;
        cell.actionContainerNode = actionsContainer;
        cell.actionContainerNodePrimary = actionsContainerPrimary;

        this.UiModder.domClass.toggle(cellNode, "collapsed", cell.row.collapsed === true);
        this.UiModder.domClass.toggle(cell.node, "reversedSign", cell.reverseValueSign == true);

        this.formatCellValue(cell);
        
        this._handleCellEditable(cell);
        return cellNode;
    }

    private _handleCellEditable(cell: SpreadsheetTableTypes.DataCell) {
        let bEditable = false;
        if (cell.column.valueType == "empty") cell.editable = false;
        else if (!this.isReadonly) {
            if (cell.editable === true) bEditable = true;
            if (typeof cell.column.editable == "function") {
                bEditable = cell.column.editable(cell);
                cell.isEditing = this.isGlobalEditingMode && bEditable;
                cell.editable = bEditable;
            }
            if (cell.isEditing && bEditable) {
                //this._createCellInput(cell);
                this._setCellEditing(cell, true);
            }
        }

        this.UiModder.domClass.toggle(cell.node, "editable", bEditable);
        this.UiModder.domClass.toggle(cell.innerNode, "hoverAuto", bEditable);
        if (bEditable && !this.isGlobalEditingMode) {
            on(cell.node, "click", lang.hitch(this, this._onClick_Cell, cell));
        }
    }

    private _drawSummaryCell(cell: SpreadsheetTableTypes.SummaryCell): HTMLElement {
        let cellNode = this.UiModder.domConstruct.create("td", {
            className: "summaryCell",
            "data-column-id": cell.column.columnID,
            "data-cell-id": cell.cellID
        }, cell.node ? cell.node : cell.row.node, cell.node ? "replace" : "last");

        
        let cellInnerNode = this.UiModder.domConstruct.create("div", {
            className: "innerContainer"
        }, cellNode);

        let cellLabelContainer: HTMLElement = null;

        // Achtung: die Summarycells werden ggf. auch ohne Descriptor erzeugt, wenn eine Spalte gar keine Summary braucht.
        if (cell.summaryDescriptor?.heading) {
            cellLabelContainer = this.UiModder.domConstruct.create("div", {
                className: "labelContainer",
                innerHTML: cell.summaryDescriptor.heading
            }, cellInnerNode);
        }

        let cellValueGroup = this.UiModder.domConstruct.create("div", {
            className: "valueGroup"
        }, cellInnerNode);

        let cellValueContainer = this.UiModder.domConstruct.create("div", {
            className: "valueContainer"
        }, cellValueGroup);

        let unitContainer = this.UiModder.domConstruct.create("div", {
            className: "unitContainer",
        }, cellValueGroup);

        if (cell.summaryDescriptor) {
            unitContainer.innerHTML = cell.column.unitLabel && cell.column.valueType != "currency" ? cell.column.unitLabel : "";

        }

        let cellInfoContainer = this.UiModder.domConstruct.create("div", {
            className: "infoContainer"
        }, cellInnerNode);



        cell.node = cellNode;
        cell.unitLabelNode = unitContainer;
        cell.displayValueNode = cellValueContainer;
        cell.infoTextNode = cellInfoContainer;

        //this.hideNode(cell.node, false, !cell.descriptor)

        this.UiModder.domClass.toggle(cellNode, "unused", !cell.summaryDescriptor);
        this.UiModder.domClass.toggle(cellNode, "collapsed", cell.row.collapsed === true);
        this.UiModder.domClass.toggle(cell.node, "reversedSign", cell.reverseValueSign == true);

        if (cell.summaryDescriptor) {
            this._addCellToCalculationQueue(cell, null, cell);
        }
        let bEditable = false;
        
        return cellNode;
    }

    private _drawRow(row: SpreadsheetTableTypes.DataRow, node: HTMLElement, placeAt: "before" | "after" | "replace"): HTMLElement {
        let rowNode = this.UiModder.domConstruct.create("tr", {
            className: "dataRow"
        }, node, placeAt);

        row.node = rowNode;
        row.cells = {};

        let entity = this.dataStore.getEntityById(row.rowID);

        this.UiModder.domClass.toggle(rowNode, "new", this.dataStore.isEntityNew(entity));

        //if (entity && this.tableData.value)
        
        let labelCol = this.UiModder.domConstruct.create("th", {
            className: "rowLabelColumn"
        }, rowNode);

        let labelNode = this.UiModder.domConstruct.create("div", {
            className: "rowLabel",
            innerHTML: row.label ? row.label : ""
        }, labelCol);

        let infoTextNode = this.UiModder.domConstruct.create("div", {
            className: "infoContainer hideIfEmpty",
            innerHTML: row.infoText ? row.infoText : ""
        }, labelCol);

        let actionContainerPrimary = this.UiModder.domConstruct.create("div", {
            className: "actionContainer primary "
        }, labelCol);

        let actionContainer = this.UiModder.domConstruct.create("div", {
            className: "actionContainer"
        }, labelCol);

        row.labelNode = labelNode;
        row.infoTextNode = infoTextNode;
        row.actionContainerNode = actionContainer;
        row.actionContainerNodePrimary = actionContainerPrimary;

        this._drawActions(row);

        this.UiModder.domClass.toggle(labelNode, "useRowLabel", !!row.label);
        

        let colArray = this.getColumns();
        for (let col of colArray) {

            let columnID = col.columnID;

            let value = EntityHelpers.getComplexProperty(entity, col.valueAttribute);

            let ID = Object.keys(row.cells).length + ":" + Object.keys(this.tableData.rows).length;

            let cell: SpreadsheetTableTypes.DataCell<T> = {
                cellID: ID,
                column: col,
                dependencies: [],
                editable: col.editable == true,
                isEditing: false,
                input: null,
                //nullValue: col.nullValue,
                row: row,
                value: value,
                dirty: false,
                originalValue: value,
                node: null,
                innerNode: null,
                actions: {},
                reverseValueSign: false
            };
            this._checkReverseSign(cell);

            this.cells[ID] = cell;

            if (this.isGlobalEditingMode) {
                if (cell.editable === true) {
                    cell.isEditing = cell.editable;
                }
            }


            // am Deskriptor ist der Schlüssel die Daten-ID
            col.cells[row.rowID] = cell;
            // in der Zeile ist der Schlüssel die Spalten-ID
            row.cells[columnID] = cell;

            if (col.validationFct) {
                cell.valid = col.validationFct(value, cell);
            }

            this._drawCell(cell);

        }

        


        return rowNode;
    }

    private _drawTable(): void {
        //data.sort((a, b) => {
        //    return a.ref_vt_cost_revenue_type.order - b.ref_vt_cost_revenue_type.order;
        //});

        //data.sort((a, b) => {
        //    return a.utilization_level_ev_finance - b.utilization_level_ev_finance;
        //});

        let tableNode = this.UiModder.domConstruct.create("table", {
            className: "spreadsheetTable"
        }, this.tableContainer, "only");

        this.UiModder.domClass.toggle(tableNode, "globalEditing", this.isGlobalEditingMode);

        this.tableData.node = tableNode;
        this.tableData.headerRowNode = null;
        this.tableData.rows = {};

        let data = this.dataStore.getCurrentCompleteList();

        this.createHeaders();

        let columns = this.getColumns();
        // falls in der allgemeinen config columnActions für alle hinterlegt sind, dann hier verteilen:
        if (this._config.columnActions) {
            for (let actionName in this._config.columnActions) {
                
                let config = this._config.columnActions[actionName];
                for (let column of columns) {
                    this.addAction(column, actionName, config);
                }
            }
        }

       
        for (let entry of data) {
            this.createDataRow(entry);
        }

        //// falls es RowActions gibt für alle, dann hier erstellen:
        //if (this._config.rowActions) {
        //    for (let actionName in this._config.rowActions) {
        //        let rows = this.getRows();
        //        let config = this._config.rowActions[actionName];
        //        for (let row of rows) {
        //            this.addAction(row, actionName, config);
        //        }
        //    }
        //}

        this._createSummaries();
    }

    private createHeaders() {
        let headRow = this.UiModder.domConstruct.create("tr", {
            className: "headerRow"
        });

        if (this.tableData.headerRowNode) {
            this.UiModder.domConstruct.place(headRow, this.tableData.headerRowNode, "replace");
        } else {
            this.UiModder.domConstruct.place(headRow, this.tableData.node, "first");
        }

        this.tableData.headerRowNode = headRow;

        let firstColumn = this.UiModder.domConstruct.create("th", {
            className: "rowHeader"
        }, headRow);


        let colArray = this.getColumns();
        for (let column of colArray) {

            let key = column.columnID;

            let headColumn = this.UiModder.domConstruct.create("th", {
                "data-column-id": key,
                className: "columnHeader"
            }, headRow);


            column.headerCellNode = headColumn;

            let cellInnerNode = this.UiModder.domConstruct.create("div", {
                className: "innerContainer"
            }, headColumn);

            let columnHeader = this.UiModder.domConstruct.create("div", {
                className: "columnLabel",
                innerHTML: column.heading ? column.heading : ""
            }, cellInnerNode);


            let cellInfoContainer = this.UiModder.domConstruct.create("div", {
                className: "infoContainer",
                innerHTML: column.infoText
            }, cellInnerNode);
            this.hideNode(cellInfoContainer, !column.infoText);


            let actionsContainerPrimary = this.UiModder.domConstruct.create("div", {
                className: "actionContainer primary w3-hide"
            }, cellInnerNode);

            let actionsContainer = this.UiModder.domConstruct.create("div", {
                className: "actionContainer w3-hide"
            }, cellInnerNode);

            if (column.actions) {
                this._drawActions(column);
            }

            if (column.collapsible === true) {
                let collapseBtn = new Button();
                collapseBtn.setup({
                    callback: lang.hitch(this, this._onClick_ToggleCollapse, key),
                    iconLeft: "fas fa-angle-left",
                    iconRight: "fas fa-angle-right",
                    parentNode: actionsContainer
                });
            }

            column.actionContainerNode = actionsContainer;
            column.actionContainerNodePrimary = actionsContainerPrimary;
            column.labelNode = columnHeader;
            column.infoTextNode = cellInfoContainer;

        }
    }
    private _handleActionStatus(target: SpreadsheetTableTypes.TableCell | SpreadsheetTableTypes.Column | SpreadsheetTableTypes.DataRow,
        action?: SpreadsheetTableTypes.Action,
        overrideEnable?: boolean,
    overrideVisible?: boolean) {
        if (!action) {
            let actions = target.actions;
            if (actions) {
                for (let actionname in actions) {
                    this._handleActionStatus(target, actions[actionname], overrideEnable);
                }
            }

            return;
        }

        //console.trace(this.id + " _handleActionStatus", action.iconClass, action) // ja da is richtig was los... shit

        let result = true;
        let visible = true;


        // readonly-Verhalten reinweben...
        // bei readonly sind die buttons erst mal nicht sichtbar
        // außer das enable-Flag erlaubt es grundsätzlich -> dann bestimmt das callback, falls vorhanden
        //
        //if (action.iconClass == "fas fa-unlock") debugger;

        let readonlyCheck = true;

        if (this.isReadonly && typeof overrideVisible != "boolean") {
            // grundsätzlich erst mal nicht erlaubt:
            readonlyCheck = false;

            // aber mit explizitem Flag schon, falls das override nicht daherkommt:
            if (action.enableIfReadonly === true) {
                readonlyCheck = true;
            } else if (action.enableIfReadonly === false) {
                // bzw. eben nicht:
                readonlyCheck = false;
            }
        }

        visible = readonlyCheck; // neue Ausgangsbasis

        if (typeof overrideVisible == "boolean") {
            visible = overrideVisible;
        } else if (action.button && action.visibleCallback && readonlyCheck == true) {
            visible = action.visibleCallback(target);
        }
        if (action.button) {
            let button = action.button as MdsLax<InstanceType<typeof Button>>;
            this.hideNode(button.domNode, !visible);
        }

        if (typeof (overrideEnable) == "boolean") {
            result = overrideEnable;
        } else if (action.button && action.enableCallback) {
            result = action.enableCallback(target);   
        }
        if (action.button) {
            let button = action.button as MdsLax<InstanceType<typeof Button>>;
            button.setReadonly(!result);
        }
        
    }
    private _drawActions(parent: SpreadsheetTableTypes.TableCell | SpreadsheetTableTypes.Column | SpreadsheetTableTypes.TableRow) {
        if (!parent) return;
        let parentNode = parent.actionContainerNode;
        let actions = parent.actions;

        if (!parentNode) return;

        let col = this.getColumn(parent as any);
        let cell = parent as SpreadsheetTableTypes.DataCell;
        if (!this.isDataCell(parent)) cell = null;

        let row = this.getRow(parent as any);

        let target: any;
        if (row) target = row;
        else if (cell) target = cell;
        else target = col;

        if (!target) return;

        this.UiModder.domConstruct.empty(parentNode);
        this.UiModder.domConstruct.empty(parent.actionContainerNodePrimary);

        this.hideNode(parentNode);
        this.hideNode(parent.actionContainerNodePrimary);

        if (!actions) return;

        for (let actionName in actions) {
            let config = actions[actionName];

            config.button = null;
            // bei readonly aufpassen:
            if (this.isReadonly) {
                // falls bei readonly explizit false gesetzt wird, ist das enable-Callback übersteuert:
                if (config.enableIfReadonly === false) {
                    continue;
                }
                // falls es kein enable-callback gibt und das enable-flag nicht explizit auf true steht, ebenfalls auslassen:
                else if (!config.enableCallback && config.enableIfReadonly !== true) {
                    continue;
                }
            }

            //// visible-Callback: komplett auslassen falls nicht true
            //if (config.visibleCallback) {
            //    if (config.visibleCallback(target) != true) {
            //        continue;
            //    } 
            //}

            let style = "spreadsheetAction"

            switch (config.priorityType) {
                case "primary":
                    style += " primaryBtn primary";
                    break;
                case "secondary":
                    style += " secondaryBtn secondary";
                    break;
                default:
                    style += " " + ( config.priorityType ? config.priorityType : "" )
                    break;
            }

            switch (config.styleClass) {
                default:
                    style += " " + (config.styleClass ? config.styleClass : "" )
                    break;
            }
          
            let btn = new Button();
            btn.setup({
                callback: lang.hitch(this, this._onClickAction, config, target),
                label: config.label,
                iconClass: config.iconClass,
                styleClass: style,
                parentNode: parentNode
            });

            switch (config.priorityType) {
                case "primary":
                    this.UiModder.domStyle.set(btn.domNode, "order", 500 + parentNode.childElementCount);
                    break;
                case "secondary":
                    this.UiModder.domStyle.set(btn.domNode, "order", 200 + parentNode.childElementCount);
                    break;
                default:
                    this.UiModder.domStyle.set(btn.domNode, "order", 0 + parentNode.childElementCount);
                    break;
                    
            }

            config.button = btn;

            this.hideNode(parentNode, false);
        }

        this._handleActionStatus(row);
    }

    private _onClickAction(config: SpreadsheetTableTypes.Action, target: SpreadsheetTableTypes.Column | SpreadsheetTableTypes.TableRow | SpreadsheetTableTypes.TableCell, evt: MouseEvent) {
        if (config.callback) {
            config.callback(target, evt);
        }
    }

    private _onKeyUpEditContainer(cell: SpreadsheetTableTypes.DataCell<T>, evt: KeyboardEvent) {
        if (this.isReadonly || cell.isEditing != true || cell.editable != true) return;

        if (evt && evt.key) {
            switch (evt.key) {
                case "Enter":
                    this._onClick_SubmitCellValue(cell, evt as any);
                    break;
                case "Escape":
                    this._onClick_CancelCellEditing(cell, evt as any);
                    break;
            }
        }
    }


    setRowStyle(row: SpreadsheetTableTypes.TableRow, style: SpreadsheetTableTypes.rowFormatterResult) {
        this.UiModder.domClass.toggle(row.node, "customStyleFormatter", !!style);
        row.node.style.removeProperty("--_rowFormatterMainBG");
        row.node.style.removeProperty("--_rowFormatterMainTXT");
        row.node.style.removeProperty("--_rowFormatterSecondaryBG");
        row.node.style.removeProperty("--_rowBorderColor");

        this.UiModder.domClass.remove(row.node, "highlight1 highlight2 highlight3 positive negative warning")

        if (style) {
            if (typeof style == "object") {
                if (typeof style.styleTemplate == "string") {
                    this.UiModder.domClass.add(row.node, style.styleTemplate);
                }
                if (style.mainBackgroundColor) {
                    row.node.style.setProperty("--_rowFormatterMainBG", style.mainBackgroundColor);
                }

                if (style.mainTextColor) {
                    row.node.style.setProperty("--_rowFormatterMainTXT", style.mainTextColor);
                }
                if (style.borderColor) {
                    row.node.style.setProperty("--_rowBorderColor", style.borderColor);
                }

                if (style.secondaryColor) {
                    row.node.style.setProperty("--_rowFormatterSecondaryBG", style.secondaryColor);
                }

                //if (typeof style.overrideInfotext == "string") {
                //    row.labelNode.innerHTML = style.overrideInfotext;
                //} else if (style.overrideInfotext instanceof HTMLElement) {
                //    this.UiModder.domConstruct.place(row.labelNode, style.overrideInfotext, "only");
                //}
                
                if (typeof style.overrideLabel == "string") {
                    row.labelNode.innerHTML = style.overrideLabel;
                } else if (style.overrideLabel instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(style.overrideLabel, row.labelNode, "only");
                }

                if (typeof style.overrideInfotext == "string") {
                    row.infoTextNode.innerHTML = style.overrideInfotext;
                } else if (style.overrideInfotext instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(style.overrideInfotext, row.infoTextNode, "only");
                }
            } else if (typeof style == "string") {
                //let newStyle: SpreadsheetTableTypes.rowFormatterResult = {
                //    mainBackgroundColor: "var(--accentThemeTransparent)",
                //    borderColor: "var(--primary)"
                //};

                //this.setRowStyle(row, newStyle);
            }
        }
    }

    setColumnStyle(column: SpreadsheetTableTypes.Column, style: SpreadsheetTableTypes.columnFormatterResult) {
        this.UiModder.domClass.toggle(column.headerCellNode, "customStyleFormatter", !!style);
        column.headerCellNode.style.removeProperty("--_colFormatterMainBG");
        column.headerCellNode.style.removeProperty("--_colFormatterMainTXT");
        column.headerCellNode.style.removeProperty("--_colFormatterSecondaryBG");
        column.headerCellNode.style.removeProperty("--_colBorderColor");

        this.UiModder.domClass.remove(column.headerCellNode, "highlight1 highlight2 highlight3 positive negative warning")


        if (style) {
            if (typeof style == "object") {
                if (typeof style.styleTemplate == "string") {
                    this.UiModder.domClass.add(column.headerCellNode, style.styleTemplate);
                }
                if (style.mainBackgroundColor) {
                    column.headerCellNode.style.setProperty("--_colFormatterMainBG", style.mainBackgroundColor);
                }

                if (style.mainTextColor) {
                    column.headerCellNode.style.setProperty("--_colFormatterMainTXT", style.mainTextColor);
                }

                if (style.secondaryColor) {
                    column.headerCellNode.style.setProperty("--_colFormatterSecondaryBG", style.secondaryColor);
                }
                if (style.borderColor) {
                    column.headerCellNode.style.setProperty("--_colBorderColor", style.borderColor);
                }

                if (typeof style.overrideInfotext == "string") {
                    column.infoTextNode.innerHTML = style.overrideInfotext;
                } else if (style.overrideInfotext instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(column.infoTextNode, style.overrideInfotext, "only");
                }

                if (typeof style.overrideLabel == "string") {
                    column.labelNode.innerHTML = style.overrideLabel;
                } else if (style.overrideLabel instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(style.overrideLabel, column.labelNode, "only");
                }

                if (style.summaryCellsStyle) {
                    let cells = this.getSummaryCells(column);
                    for (let cell of cells) {
                        this.setCellStyle(cell, style.summaryCellsStyle);
                    }
                }
            }
                //} else if (style == "highlight1") {
                //    let newStyle: SpreadsheetTableTypes.columnFormatterResult = {
                //        mainBackgroundColor: "var(--accentThemeTransparent)",
                //        borderColor: "var(--primary)",
                //        summaryCellsStyle: style
                //    };

                //    this.setColumnStyle(column, newStyle);
            //}
        }
    }

    setCellStyle(datacell: SpreadsheetTableTypes.DataCell, style: SpreadsheetTableTypes.cellFormatterResult)
    setCellStyle(summaryCell: SpreadsheetTableTypes.SummaryCell, style: SpreadsheetTableTypes.cellFormatterResult)
    setCellStyle(cell: SpreadsheetTableTypes.TableCell, style: SpreadsheetTableTypes.cellFormatterResult) {

        this.UiModder.domClass.toggle(cell.node, "customStyleFormatter", !!style);
        cell.node.style.removeProperty("--_cellFormatterMainBG");
        cell.node.style.removeProperty("--_cellFormatterMainTXT");
        cell.node.style.removeProperty("--_cellFormatterSecondaryBG");
        cell.node.style.removeProperty("--_cellFormatterBorderColor");

        this.UiModder.domClass.remove(cell.node, "highlight1 highlight2 highlight3 positive negative warning")


        if (style) {
            if (typeof style == "object") {
                if (typeof style.styleTemplate == "string") {
                    this.UiModder.domClass.add(cell.node, style.styleTemplate);
                } 
                if (style.mainBackgroundColor) {
                    cell.node.style.setProperty("--_cellFormatterMainBG", style.mainBackgroundColor);
                }

                if (style.mainTextColor) {
                    cell.node.style.setProperty("--_cellFormatterMainTXT", style.mainTextColor);
                }

                if (style.secondaryColor) {
                    cell.node.style.setProperty("--_cellFormatterSecondaryBG", style.secondaryColor);
                }
                if (style.borderColor) {
                    cell.node.style.setProperty("--_cellFormatterBorderColor", style.borderColor);
                }

                if (typeof style.overrideInfotext == "string") {
                    cell.infoTextNode.innerHTML = style.overrideInfotext;
                } else if (style.overrideInfotext instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(style.overrideInfotext, cell.infoTextNode, "only");
                }

                if (typeof style.overrideDisplayValue == "string") {
                    cell.displayValueNode.innerHTML = style.overrideDisplayValue;
                } else if (style.overrideInfotext instanceof HTMLElement) {
                    this.UiModder.domConstruct.place(style.overrideDisplayValue, cell.displayValueNode, "only");
                }

                if (typeof style.overrideUnitLabel == "string") {
                    cell.unitLabelNode.innerHTML = style.overrideUnitLabel;
                }
            //    else if (style.overrideUnitLabel instanceof HTMLElement) {
            //        this.UiModder.domConstruct.place(style.overrideUnitLabel, cell.unitLabelNode, "replace");
            //    }
            } /*else if (style == "highlight1") {

                let newStyle: SpreadsheetTableTypes.cellFormatterResult = {
                    mainBackgroundColor: "var(--accentThemeTransparent)",
                    borderColor: "var(--primary)"
                };

                if (this.isSummaryCell(cell)) {
                    newStyle.mainBackgroundColor = "var(--primary)";
                    newStyle.mainTextColor = "var(--primaryText)";
                }

                this.setCellStyle(cell as any, newStyle);
            }*/
            //if (result.overrideLabel)
        }

    }
    /**
     * Veranlasst ein Update bzw. Neuzeichnen eines Oberflächenteils, wenn sich Daten durch Manipulation von außen geändert haben und die Formatter nicht von selber darauf reagieren.
     * @param target 
     */
    sendUIsignal(target: SpreadsheetTableTypes.TableRow<T> | SpreadsheetTableTypes.DataCell<T> | SpreadsheetTableTypes.Column<T>) {
        this._handleStyleFormatter(target);
    }

    private _handleStyleFormatter(target) {
        // Hinweise: manches davon definitiv noch WIP!

        if (this.isDataCell(target)) {
            let cell = target as SpreadsheetTableTypes.DataCell<T>;

            if (typeof cell.column.dataCellStyleFormatter == "function") {
                let result = cell.column.dataCellStyleFormatter(cell);
                this.setCellStyle(cell, result);
            }

            if (typeof cell.column.headerStyleFormatter == "function") {
                this._handleStyleFormatter(cell.column);
            }
            
            if (typeof cell.row.rowStyleFormatter == "function") {
                this._handleStyleFormatter(cell.row);
            }

        } else if (this.isColumn(target)) {
            let col = target as SpreadsheetTableTypes.Column<T>;

            if (typeof col.headerStyleFormatter == "function") {
                let scells = this.getSummaryCells(col);
                let result = col.headerStyleFormatter(col);
                this.setColumnStyle(col, result);
            }

        } else if (this.isDataRow(target)) {
            let row = target as SpreadsheetTableTypes.DataRow<T>;
            
            if (typeof row.rowStyleFormatter == "function") {
                let result = row.rowStyleFormatter(row);
                this.setRowStyle(row, result);
            }
            
        } else if (this.isSummaryCell(target)) {
            let summaryCell = this.getSummaryCell(target);
            if (summaryCell.summaryDescriptor.styleFormatter) {
                let result = summaryCell.summaryDescriptor.styleFormatter(summaryCell);
                this.setCellStyle(summaryCell, result);
            }
        }
    }

    private _onClick_ToggleCollapse(columnID: string) {
        if (!columnID) return;
        let descriptor = this.tableData.columns[columnID];

        let target = descriptor.collapsed !== true;
        if (descriptor.collapsible !== true) target = false;

        for (let cellKey in descriptor.cells) {
            let cell = descriptor.cells[cellKey];
            this.UiModder.domClass.toggle(cell.node, "collapsed", target === true);
        }
        this.UiModder.domClass.toggle(descriptor.headerCellNode, "collapsed", target === true);
        
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(SpreadsheetTable);